import { apiClient } from '../lib/apiClient';

export function listNotifications(params) {
  return apiClient.get('/notifications', params);
}
export function getUnreadCount() {
  return apiClient.get('/notifications/unread-count');
}
export function markNotificationRead(id) {
  return apiClient.patch(`/notifications/${id}/read`, {});
}
export function markAllNotificationsRead() {
  return apiClient.post('/notifications/mark-all-read');
}
export function getNotificationPreferences() {
  return apiClient.get('/notifications/preferences');
}
export function updateNotificationPreferences(preferences) {
  return apiClient.patch('/notifications/preferences', preferences);
}
